import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Link from "@mui/material/Link";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import AvatarGroup from '@mui/material/AvatarGroup';
import Avatar from '@mui/material/Avatar';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Skeleton from '@mui/material/Skeleton';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Pagination from '@mui/material/Pagination';
import WordCloud from 'react-d3-cloud';
import { Dayjs } from 'dayjs';
// import ReactWordcloud from 'react-wordcloud';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Filter } from '../components/common/filter';
import { CustomNoRowsOverlay } from '../components/common/datagrid';
import { homeStyle } from '../styles/pages/home';

import { useQueryDashboard } from '../api/dashboard';
import { DashboardData, RecentActivity, LatestProject, LatestArticle, WordForCloud } from '../types/dashboard';
import { useQueryProject } from '../api/project';
import { ProjectList } from '../types/project';
import { useQueryArticle } from '../api/article';
import { Article } from '../types/article'
import { selectAuthUser } from '../store/auth/selector';

const FormattedContent = (keyword: string | undefined, maxLength: number) => {
  let result: string;
  keyword !== undefined && keyword?.length <= maxLength ? result = keyword : result = [keyword?.slice(0, maxLength), "..."].join("");
  return result;
}

export function Home() {
  const navigate = useNavigate()
  const profile = useSelector(selectAuthUser)

  const [selectedTab, setSelectedTab] = useState('2')
  const [startDateValue, setStartDateValue] = useState<Dayjs | null>(null)
  const [EndDatevalue, setEndDateValue] = useState<Dayjs | null>(null)
  const [searchResult, setSearchResult] = useState('')
  const [showSearchPage, setShowSearchPage] = useState(false)
  const [pageProject, setPageProject] = useState(0)
  const [countProject, setCountProject] = useState(0)
  const [pageArticle, setPageArticle] = useState(0)
  const [countArticle, setCountArticle] = useState(0)
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null)
  const [recentActivity, setRecentActivity] = useState<RecentActivity[]>([])
  const [latestProject, setLatestProject] = useState<LatestProject[]>([])
  const [latestArticle, setLatestArticle] = useState<LatestArticle[]>([])
  const [wordcloud, setWordcloud] = useState<WordForCloud[]>([])
  const [projectList, setProjectList] = useState<ProjectList[]>([])
  const [articleList, setArticleList] = useState<Article[]>([])

  const handleTabButtons = (event, newValue) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  const getDashboard = useQueryDashboard({
    query: {
      userId: profile.userId,
    },
    options: {
      onSuccess: (res) => {
        setDashboardData(res.data)
        setRecentActivity(res.data.recentActivity)
        setLatestProject(res.data.recentProjects)
        setLatestArticle(res.data.latestArticle)
        setWordcloud(res.data.wordCloud)
      },
      onError: () => {
        setDashboardData(null)
        setRecentActivity([])
        setLatestProject([])
        setLatestArticle([])
        setWordcloud([])
      }
    },
  });

  const getProject = useQueryProject({
    query: {
      userId: profile.userId,
      search: searchResult,
      take: 12,
      page: pageProject,
      startDate: startDateValue ? startDateValue?.format('YYYY-MM-DD') : "",
      endDate: EndDatevalue ? EndDatevalue?.format('YYYY-MM-DD') : ""
    },
    options: {
      enabled: false,
      onSuccess: (res) => {
        setProjectList(res.data.projects);
        setCountProject(res.data.totalPages)
      },
      onError: () => {
        setProjectList([]);
      }
    },
  });

  const getArticle = useQueryArticle({
    query: {
      search: searchResult,
      take: 12,
      page: pageArticle, //
      startDate: startDateValue ? startDateValue?.format('YYYY-MM-DD') : "",
      endDate: EndDatevalue ? EndDatevalue?.format('YYYY-MM-DD') : ""
    },
    options: {
      enabled: false,
      onSuccess: (res) => {
        setArticleList(res.data.articles);
        setCountArticle(res.data.totalPages)
      },
      onError: () => {
        setArticleList([]);
      }
    },
  });


  const handleArticleChange = (event, value) => {
    setPageArticle(value - 1);
  };

  const handleProjectChange = (event, value) => {
    setPageProject(value - 1);
  };

  useEffect(() => {
    if(searchResult === null || searchResult === ""){
      setShowSearchPage(false)
      setProjectList([])
      setArticleList([])
    }

  }, [searchResult])

  useEffect(() => {
    getArticle.refetch()

  }, [pageArticle])

  useEffect(() => {
    getProject.refetch()

  }, [pageProject])

  return (
    <Container maxWidth={false} sx={homeStyle.contentContainer}>
      <Grid container spacing={2} sx={homeStyle.contentContainerGrid1}>
        <Grid xs={3}>
          <Typography variant="h3" sx={homeStyle.contentContainerGrid1Item1Typography}>{showSearchPage ? "Search" : "Dashboard"}</Typography>
        </Grid>
        <Grid container spacing={2} xs sx={homeStyle.contentContainerGrid1Item2}>
          <Filter 
            placeholder="Search" 
            onSearchChange={(searchTerm) => setSearchResult(searchTerm)} 
            onSearchClick={() => {
              setShowSearchPage(true)
              getProject.refetch()
              getArticle.refetch()
            }}
            startDate={(startDate) => setStartDateValue(startDate)}
            endDate={(endDate) => setEndDateValue(endDate)}
          />
        </Grid>
      </Grid>

      {showSearchPage === false && (
        <Grid container spacing={2}>
        <Grid container spacing={2} xs={12}>
          {profile.role === "Admin" && (
            <Grid xs={3}>
            <Stack direction="column" spacing={2}>
              <Card variant="outlined" sx={homeStyle.card1}>
                {getDashboard.isLoading || getDashboard.isFetching ? 
                  (<Skeleton variant="rounded" width="auto" height={150} />) : (
                  <CardContent>
                    <Typography variant="subtitle1" sx={homeStyle.card1CardContentTypography}>Total Project</Typography>
                    <Typography variant="h3" sx={homeStyle.card1CardContentTypography2}>{dashboardData?.totalProject}</Typography>
                  </CardContent>
                )}
              </Card>
              <Card variant="outlined" sx={homeStyle.card1}>
                {getDashboard.isLoading || getDashboard.isFetching ? 
                  (<Skeleton variant="rounded" width="auto" height={150} />) : (
                  <CardContent>
                    <Typography variant="subtitle1" sx={homeStyle.card1CardContentTypography}>Total Article</Typography>
                    <Typography variant="h3" sx={homeStyle.card1CardContentTypography2}>{dashboardData?.totalArticle}</Typography>
                  </CardContent>
                  )}
              </Card>
            </Stack>
            </Grid>
          )}
          <Grid xs>
            <Card variant="outlined" sx={homeStyle.card2}>
              {getDashboard.isLoading || getDashboard.isFetching ? 
                (<Skeleton variant="rounded" width="auto" height="inherit" />) : (
                <CardContent sx={homeStyle.card2CardContent}>
                  <Typography variant="subtitle1" sx={homeStyle.card2CardContentTypography}>Recent Project Activity</Typography>
                  <Box sx={homeStyle.card2CardContentBox}>
                    {recentActivity.map(item => (
                      <Grid xs={12} container spacing={2} key={item.projectId}>
                        <Grid xs={12}>
                          <Stack direction="row" spacing={2}>
                            <CardMedia
                              component="img"
                              height="194"
                              image={item.thumbnail}
                              sx={homeStyle.card2CardMedia}
                            />
                            <Box sx={homeStyle.card2CardContentBoxGridItemBox}>
                              <Typography variant="h6">{item.projectName}</Typography>
                              <Box sx={homeStyle.card2CardContentBoxGridItemBoxBox}>
                                <Typography variant="subtitle1">{item.projectAuthor}</Typography>
                                <Typography color="textSecondary">{item.date}</Typography>
                              </Box>
                            </Box>
                          </Stack>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>
                </CardContent>
              )}
            </Card>
          </Grid>
        </Grid>
        <Grid xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <Typography variant="subtitle1">Latest Project</Typography>
                  <Typography variant="subtitle1" color="textSecondary">Latest activity or change in projects</Typography>
                </Grid>
                <Grid xs={6}>
                  {profile.role === "Admin" || profile.role === "Lecturer" ? (
                    <Box sx={homeStyle.card3CardContentGridItem1Box}>
                      <Button variant="contained" color="info" onClick={() => navigate('/project')} sx={homeStyle.card3CardContentGridItem1BoxButton}>See all project</Button>
                    </Box>
                  ) : ""}
                </Grid>
                <Grid container spacing={2} xs={12}>
                  {getDashboard.isLoading || getDashboard.isFetching ? 
                    [...Array(4)].map(item => (
                      <Grid xs={3}>
                        <Card sx={homeStyle.card4} elevation={4}>
                          <Skeleton variant="rounded" width="auto" height={425} />
                        </Card>
                      </Grid>
                      
                    ))
                    : 
                    latestProject.slice(0, 4).map(item => (
                      <Grid xs={3}>
                        <Card sx={homeStyle.card4} elevation={4} key={item.projectId}>
                          <CardContent>
                            <Link onClick={() => navigate(`/project-detail/${item.projectId}`)} underline="none" sx={homeStyle.card4CardContentLink}>
                              <CardMedia
                                component="img"
                                width="260px"
                                height="200px"
                                image={item.projectThumbnail}
                                sx={homeStyle.card4CardMedia}
                              />
                              <Typography variant="subtitle1" gutterBottom>{item.projectOwner}</Typography>
                              <Typography variant="h5" gutterBottom sx={homeStyle.card4CardContentTypography1}>{FormattedContent(item.projectName, 18)}</Typography>
                              <Typography variant="subtitle2" gutterBottom sx={homeStyle.card4CardContentTypography2}>{FormattedContent(item.projectDescription, 70)}</Typography>
                              <Typography variant="subtitle2" color="textSecondary" gutterBottom>{item.publishedDate}</Typography>
                              <Box sx={homeStyle.card4CardContentBox1}>
                                <AvatarGroup spacing="small" max={3}>
                                  {item.collaborators?.map((collab) => (
                                    <Avatar key={collab.userId} alt={collab.fullName} src={collab.avatar} sx={homeStyle.card4CardContentBox2AvatarGroupAvatar}/>
                                  ))}
                                </AvatarGroup>
                                <Typography variant="subtitle2">{item.totalCollaborators} Collaborators</Typography>
                              </Box>
                            </Link>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <Typography variant="subtitle1">Latest Article</Typography>
                  <Typography variant="subtitle1" color="textSecondary">Latest activity or change in articles</Typography>
                </Grid>
                <Grid xs={6}>
                  {profile.role === "Admin" || profile.role === "Lecturer" ? (
                    <Box sx={homeStyle.card3CardContentGridItem1Box}>
                      <Button variant="contained" color="info" onClick={() => navigate('/article-list')} sx={homeStyle.card3CardContentGridItem1BoxButton}>See all article</Button>
                    </Box>
                  ) : ""}
                  
                </Grid>
                <Grid container spacing={2} xs={12}>
                  {getDashboard.isLoading || getDashboard.isFetching ? 
                    [...Array(4)].map(item => (
                      <Grid xs={3}>
                        <Card sx={homeStyle.card4} elevation={4}>
                          <Skeleton variant="rounded" width="auto" height={425} />
                        </Card>
                      </Grid>
                    ))
                    : 
                    latestArticle.slice(0, 4).map(item => (
                      <Grid xs={3}>
                        <Card sx={homeStyle.card4} elevation={4} key={item.articleId}>
                          <CardContent>
                            <Link onClick={() => navigate(`/article-detail/${item.articleId}`)} underline="none" sx={homeStyle.card4CardContentLink}>
                              <CardMedia
                                component="img"
                                width="260px"
                                height="200px"
                                image={item.thumbnail}
                                sx={homeStyle.card4CardMedia}
                              />
                              <Typography variant="subtitle1" gutterBottom>{item.publisher}</Typography>
                              <Typography variant="h5" gutterBottom sx={homeStyle.card4CardContentTypography1}>{FormattedContent(item.title, 18)}</Typography>
                              <Box sx={homeStyle.card4CardContentBox2}>
                                <Typography variant="subtitle2">{FormattedContent(item.description, 120)}</Typography>
                              </Box>
                              <Typography variant="subtitle2" color="textSecondary" sx={homeStyle.card4CardContentTypography2}>{item.publishedDate}</Typography>
                            </Link>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={12}>
          <Paper variant="outlined" elevation={0} sx={homeStyle.contentContainerGrid2ItemPaper}>
            {getDashboard.isLoading || getDashboard.isFetching ? 
              (<Skeleton variant="rounded" width="auto" height={700} />) : (
                <WordCloud
                  data={wordcloud}
                  width={700}
                  height={300}
                  font="Open Sans, sans-serif"
                  fontWeight={900}
                  fontSize={(word) => Math.log2(word.value) * 5}
                  spiral="rectangular"
                  rotate={0}
                  fill={(d, i) => {
                    const colors = ["#F18700", "#1A6B0E", "#6B1A0E", "#0E496B"];
                    return colors[i % colors.length];
                  }}
                />
              )}
          </Paper>
        </Grid>
        {/* <Grid xs={12}>
          <Paper variant="outlined" elevation={0} sx={homeStyle.contentContainerGrid2ItemPaper}>
            <ReactWordcloud words={words} options={{
              colors: ["#F18700", "#1A6B0E", "#6B1A0E", "#0E496B"],
              fontWeight: "900",
              fontFamily: "Open Sans, sans-serif",
              fontSizes: [20, 50],
              padding: 1,
              rotations: 2,
              rotationAngles: [-90, 0],
              scale: 'log',
              spiral: 'rectangular',
            }}/>
          </Paper>
        </Grid> */}
        </Grid>
      )}

      {showSearchPage === true && (
        <TabContext value={selectedTab}>
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Typography variant="h3" color="textSecondary" sx={homeStyle.contentContainerTabContextGridItem1Typography}>Result for <span style={{ color: 'black' }}>{searchResult}</span></Typography>
            </Grid>
            <Grid xs={12}>
              <Paper sx={homeStyle.contentContainerTabContextGridItem2Paper}>
                <ToggleButtonGroup
                  size="small"
                  value={selectedTab}
                  exclusive
                  onChange={handleTabButtons}
                  aria-label="tab buttons"
                >
                  {/* <ToggleButton value="1" >
                    All
                  </ToggleButton> */}
                  <ToggleButton value="2">
                    Project 
                  </ToggleButton>
                  <ToggleButton value="3">
                    Article 
                  </ToggleButton>
                </ToggleButtonGroup>
              </Paper>
            </Grid>
            <Grid xs={12}>
              {/* <TabPanel value="1" sx={homeStyle.contentContainerTabContextGridItem3TabPanel}>
                <Paper 
                  variant="outlined" 
                  elevation={0} 
                  sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaper}
                >
                  <Grid container>
                    {[...Array(12)].map((index => (
                      <Grid xs={2}>
                        <Card elevation={0}>
                          <CardContent>
                            <CardMedia
                              component="img"
                              width="260px"
                              height="120px"
                              image="/assets/image/dummy.png"
                              sx={homeStyle.card4CardMedia}
                            />
                            <Typography variant="subtitle1">John Doe</Typography>
                            <Typography variant="h6">Project Name</Typography>
                            <Typography variant="subtitle2">Ut sodales, ex sit amet consectetur accumsan, nibh ex sollicitudin metus</Typography>
                            <Typography variant="subtitle2" color="textSecondary" sx={homeStyle.card4CardContentTypography}>August 10, 2023</Typography>
                            <Box sx={homeStyle.card4CardContentBox}>
                              <AvatarGroup spacing="small" max={4} sx={homeStyle.card4CardContentBoxAvatarGroup}>
                                <Avatar alt="Remy Sharp" src="/assets/image/avatar.jpg" sx={homeStyle.card4CardContentBoxAvatarGroupAvatar}/>
                                <Avatar alt="Travis Howard" src="/assets/image/avatar.jpg" sx={homeStyle.card4CardContentBoxAvatarGroupAvatar} />
                                <Avatar alt="Cindy Baker" src="/assets/image/avatar.jpg" sx={homeStyle.card4CardContentBoxAvatarGroupAvatar} />
                                <Avatar alt="Agnes Walker" src="/assets/image/avatar.jpg" sx={homeStyle.card4CardContentBoxAvatarGroupAvatar} />
                                <Avatar alt="Trevor Henderson" src="/assets/image/avatar.jpg" sx={homeStyle.card4CardContentBoxAvatarGroupAvatar} />
                              </AvatarGroup>
                              <Typography variant="subtitle2">10 Collaborators</Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    )))}
                    {[...Array(6)].map((index => (
                      <Grid xs={2}>
                        <Card elevation={0}>
                          <CardContent>
                            <CardMedia
                              component="img"
                              width="260px"
                              height="120px"
                              image="/assets/image/dummy.png"
                              sx={homeStyle.card4CardMedia}
                            />
                            <Typography variant="subtitle1">Publisher</Typography>
                            <Typography variant="h6">Article 1</Typography>
                            <Typography variant="subtitle2">Ut sodales, ex sit amet consectetur accumsan, nibh ex sollicitudin metus</Typography>
                            <Typography variant="subtitle2" color="textSecondary" sx={homeStyle.card4CardContentTypography}>August 10, 2023</Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    )))}
                    <Grid xs={12}>
                      <Box sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaperGridItemBox}>
                        <Pagination count={10} variant="outlined" shape="rounded" color="primary" />
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </TabPanel> */}
              <TabPanel value="2" sx={homeStyle.contentContainerTabContextGridItem3TabPanel}>
                <Paper variant="outlined" elevation={0} sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaper}>
                  {projectList && projectList.length > 0 ? (
                    <Grid container spacing={2}>
                      {projectList.map((value => (
                        <Grid xs={3} key={value.projectId}>
                          <Card elevation={4} sx={homeStyle.card4Search}>
                            <CardContent>
                              <Link onClick={() => navigate(`/project-detail/${value.projectId}`)} underline="none" sx={homeStyle.card4CardContentLink}>
                                <CardMedia
                                  component="img"
                                  width="260px"
                                  height="200px"
                                  image={value.projectThumbnail}
                                  sx={homeStyle.card4CardMedia}
                                />
                                <Typography variant="subtitle1" gutterBottom>{value.projectOwner}</Typography>
                                <Typography variant="h5" gutterBottom sx={homeStyle.card4CardContentTypography1}>{FormattedContent(value.projectName, 23)}</Typography>
                                <Typography variant="subtitle2" gutterBottom sx={homeStyle.card4CardContentTypography2}>{FormattedContent(value.projectDescription, 100)}</Typography>
                                <Typography variant="subtitle2" color="textSecondary" gutterBottom sx={homeStyle.card4CardContentTypography2}>{value.latestUpdate}</Typography>
                                <Box sx={homeStyle.card4CardContentBox1}>
                                  <AvatarGroup spacing="small" max={4}>
                                    {value.collaborators.map((item) => (
                                      <Avatar key={item.userId} alt={item.fullName} src={item.avatar} sx={homeStyle.card4CardContentBox2AvatarGroupAvatar}/>
                                    ))}
                                  </AvatarGroup>
                                  <Typography variant="subtitle2">{value.totalCollaborators} Collaborators</Typography>
                                </Box>
                              </Link>
                            </CardContent>
                          </Card>
                        </Grid>
                      )))}
                      <Grid xs={12}>
                        <Box sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaperGridItemBox}>
                          <Pagination count={countProject} page={pageProject + 1} onChange={handleProjectChange} variant="outlined" shape="rounded" color="primary" />
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <CustomNoRowsOverlay/>
                  )}
                </Paper>
              </TabPanel>
              <TabPanel value="3" sx={homeStyle.contentContainerTabContextGridItem3TabPanel}>
                <Paper variant="outlined" elevation={0} sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaper}>
                  {articleList && articleList.length > 0 ? (
                    <Grid container spacing={2}>
                      {articleList.map((value => (
                        <Grid xs={3} key={value.articleId}>
                          <Card elevation={4} sx={homeStyle.card4Search}>
                            <CardContent>
                              <Link onClick={() => navigate(`/article-detail/${value.articleId}`)} underline="none" sx={homeStyle.card4CardContentLink}>
                                <CardMedia
                                  component="img"
                                  width="260px"
                                  height="200px"
                                  image={value.thumbnail}
                                  sx={homeStyle.card4CardMedia}
                                />
                                <Typography variant="subtitle1" gutterBottom>{value.publisher}</Typography>
                                <Typography variant="h5" gutterBottom sx={homeStyle.card4CardContentTypography1}>{FormattedContent(value.title, 23)}</Typography>
                                <Box sx={homeStyle.card4CardContentBox2}>
                                  <Typography variant="subtitle2" gutterBottom sx={homeStyle.card4CardContentTypography2}>{FormattedContent(value.description, 200)}</Typography>
                                </Box>
                                <Typography variant="subtitle2" color="textSecondary" sx={homeStyle.card4CardContentTypography2}>{value.publishedDate}</Typography>
                              </Link>
                            </CardContent>
                          </Card>
                        </Grid>
                      )))}
                      <Grid xs={12}>
                        <Box sx={homeStyle.contentContainerTabContextGridItem3TabPanelPaperGridItemBox}>
                          <Pagination count={countArticle} page={pageArticle + 1} onChange={handleArticleChange} variant="outlined" shape="rounded" color="primary" />
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <CustomNoRowsOverlay/>
                  )}
                </Paper>
              </TabPanel>
            </Grid>
          </Grid>
        </TabContext>
      )}
    </Container>
  );  
}
